import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const createNewPurchaseOrder = async (
  details,
  orderItems,
  shippingAddress,
  billingAddress,
  organisation,
  createdByUser,
  attachments,
) => {
  try {
    let params = {
      details,
      orderItems,
      shippingAddress,
      billingAddress,
      createdByUser,
      organisation,
      attachments,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "purchase-orders",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const getAllPurchaseOrder = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 99999,
  vendors = [],
  status = [],
  totalCost = {},
  submissionDate = [],
  dueDate = [],
  sort = [],
  role,
  allIds
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    details: {
      vendor: {
        id: {
          $in: vendors,
        },
      },
    },
    orderItems: {},
  };

  if (status) {
    assetFilters.status = {
      $eq: status[0],
    };
  }

  if (submissionDate.length === 1) {
    assetFilters.createdAt = {
      $gte: submissionDate[0],
    };
  } else if (submissionDate.length === 2) {
    assetFilters.createdAt = {
      $gte: submissionDate[0],
      $lte: submissionDate[1],
    };
  }

  if (dueDate.length === 1) {
    assetFilters.details.dueDate = {
      $gte: dueDate[0],
    };
  } else if (dueDate.length === 2) {
    assetFilters.details.dueDate = {
      $gte: dueDate[0],
      $lte: dueDate[1],
    };
  }

  if (totalCost.from && !totalCost.to) {
    assetFilters.orderItems.totalCost = {
      $gte: Number(totalCost.from),
    };
  } else if (!totalCost.from && totalCost.to) {
    assetFilters.orderItems.totalCost = {
      $lte: Number(totalCost.to),
    };
  } else if (totalCost.to && totalCost.from) {
    assetFilters.orderItems.totalCost = {
      $gte: Number(totalCost.from),
      $lte: Number(totalCost.to),
    };
  }

  // shippingAddress companyName

  if (role !== "super_admin") {
    assetFilters.shippingAddress = {
      companyName: {
        id: {
          $in: allIds,
        },
      },
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "image",
      "attachments",
      "location",
      "vendors",
      "customFields",
      "procedure",
      "createdByUser",
      "category",
      "createdByUser.profileImage",
      "inventory",
      "inventory.location",
      "inventory.area",
      "details",
      "details.vendor",
      "details.mainLocation",
      "details.people",
      "details.people.profileImage",
      "orderItems",
      "orderItems.items",
      "orderItems.items.location",
      "orderItems.items.part",
      "shippingAddress",
      "shippingAddress.companyName",
      "shippingAddress.area",
      "billingAddress",
      "updatedByUser",
      "approvedByUser",
      "updatedByUser.profileImage",
      "logo",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }
  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `purchase-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let dataObj = {
      response: response.data.data,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    // return the_response;
    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const updatePurchaseOrder = async (
  details,
  orderItems,
  shippingAddress,
  billingAddress,
  organisation,
  id,
  attachments
) => {
  try {
    let params = {
      details,
      orderItems,
      shippingAddress,
      billingAddress,
      organisation,
      attachments,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "purchase-orders/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const deletePurchaseOrder = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + "purchase-orders/removePurchaseOrders",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return {
      status: err?.response?.status,
    };
  }
};

export const fulFillPurchaseOrder = async (
  orderItems,
  isFulfill = "yes",
  organisation,
  ID,
  status
) => {
  try {
    let params = {
      orderItems: orderItems?.orderItems,
      isFulfill,
      organisation,
      status,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "status/" + ID,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return err?.response?.status;
  }
};

export const updatePurchaseOrderStatus = async (
  ID,
  status,
  declinedReason,
  sendVendor
) => {
  try {
    let params = {
      status,
    };

    if (declinedReason) {
      params.declinedReason = declinedReason;
    }

    if (sendVendor) {
      params.sendToVendor = "yes";
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "status/" + ID,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        responseType: "arraybuffer",
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return err?.response;
  }
};
